/* unplugin-vue-components disabled */import { render } from "./CartViewItemCard.vue?vue&type=template&id=d3b630c2&scoped=true&ts=true"
import script from "./CartViewItemCard.vue?vue&type=script&lang=ts"
export * from "./CartViewItemCard.vue?vue&type=script&lang=ts"

import "./CartViewItemCard.vue?vue&type=style&index=0&id=d3b630c2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3b630c2"]])

export default __exports__